import { ByteArray } from "../ByteArray"
import { ICommand } from "./ICommand"

export class CMDPsPlayerReport implements ICommand
{

	public FromDate : string = "";
	public ToDate : string = "";
	public GameCategory : number = 0;

	public constructor()
	{
	}

	public fromBytes(ba : ByteArray) : void
	{
		this.FromDate = ba.readString();
		this.ToDate = ba.readString();
		this.GameCategory = ba.readInt53();
	}

	public toBytes() : ByteArray
	{
		let ba: ByteArray = new ByteArray();

		ba.writeString(this.FromDate);
		ba.writeString(this.ToDate);
		ba.writeUint53(this.GameCategory);

		return ba;
	}

	public clone() : ICommand
	{
		let cmd : ICommand = new CMDPsPlayerReport();
		cmd.fromBytes(this.toBytes());

		return cmd;
	}

	public toString() : string
	{
		let str:string = '';
		str += 'FromDate(S)='+this.FromDate+' ';
		str += 'ToDate(S)='+this.ToDate+' ';
		str += 'GameCategory(Q)='+this.GameCategory+' ';
		return str;
	}

	public getCmdID() : number
	{
		return 55012;
	}

	public getCmdName() : string
	{
		return 'PsPlayerReport';
	}

}
